module.exports = __webpack_public_path__ + "img/success.0b4ccf5a.svg";